

<div class="modal-body" id="receipt-section">
    <div class="card">
        <div class="card-body p-0">
            <div class="card-box m-0 d-flex-center" *ngIf="loading">
                <span class="spinner-grow spinner-border-sm mr-2"></span> Please wait while loading receipt
            </div>
            <div class="card-box m-0" *ngIf="record && !loading">
                <div class="row" *ngIf="isPrintLogo">
                    <div class="col-lg-12">
                        <banner-setting> </banner-setting>
                    </div>
                    <div class="col-lg-12">
                        <h4 class="box-title mt-3">RECEIPT</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="table-responsive table-responsive-lg text-black">
                            <table class="table table-sm table-borderless table-centered text-black">
                                <tbody>
                                    <tr>
                                        <th>Receipt No</th>
                                        <td>
                                            <span class="mr-1">:</span>
                                            <span [textContent]="record.receiptNo || '--'"></span>
                                        </td>
                                        <th>
                                            <span *ngIf="isAdmission">Admission No</span>
                                            <span *ngIf="!isAdmission">Appointment No</span>
                                        </th>
                                        <td>
                                            <span class="mr-1">:</span>
                                            <span [textContent]="admission.admissionNo"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Ref No</th>
                                        <td>
                                            <span class="mr-1">:</span>
                                            <span [textContent]="record.receiptId"></span>
                                        </td>
                                        <th>
                                            <span *ngIf="isAdmission">Admission Date</span>
                                            <span *ngIf="!isAdmission">Appointment Date</span>
                                        </th>
                                        <td>
                                            <span class="mr-1">:</span>
                                            <span *ngIf="isAdmission" [textContent]="admission.admissionDate | date: 'dd-MM-yyyy, h:mm:ss a'"></span>
                                            <span *ngIf="!isAdmission">
                                                <span [textContent]="admission.admissionDate | date: 'dd-MM-yyyy'"></span>
                                                <span [textContent]="' ' + admission.timeString"></span>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Receipt Date</th>
                                        <td>
                                            <span class="mr-1">:</span>
                                            <span [textContent]="record.createdDate | date:'dd-MM-yyyy, h:mm:ss a'"></span>
                                        </td>
                                        <th>Doctor Name</th>
                                        <td>
                                            <span class="mr-1">:</span>
                                            <span [textContent]="'Dr. ' + (admission.providerName || '------')"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Patient Name</th>
                                        <td>
                                            <span class="mr-1">:</span>
                                            <span>
                                                <span [textContent]="admission.fullName + ', '"></span>
                                                <span [textContent]="(admission.gender === 'F' ? 'Female' : 'Male') + ', '"></span>
                                                <span [textContent]="admission.age + 'yrs'"></span>
                                            </span>
                                        </td>
                                        <th>Department</th>
                                        <td>
                                            <span class="mr-1">:</span>
                                            <span [textContent]="admission.departmentName"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>UMR No</th>
                                        <td>
                                            <span class="mr-1">:</span>
                                            <span [textContent]="admission.umrNo"></span>
                                        </td>
                                        <th>Address</th>
                                        <td>
                                            <span class="mr-1">:</span>
                                            <span [textContent]="admission.fullAddress"></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-12">
                        <div class="table-responsive table-responsive-lg">
                            <table class="table table-bordered table-sm text-black" *ngIf="record">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>PAY TYPE NAME</th>
                                        <th>PAID DATE</th>
                                        <th>PAID AMOUNT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of records; index as i;">
                                        <td>{{i+1}}</td>
                                        <td [textContent]="item.payTypeName"></td>
                                        <td [textContent]="item.createdDate | date:'dd-MM-yyyy, hh:mm a'"></td>
                                        <td [textContent]="item.cost | currency:'INR' ">
                                    </tr>
                                </tbody>
                                <thead>
                                    <tr>
                                        <th colspan="3" class="text-right">TOTAL PAID AMOUNT</th>
                                        <th [textContent]="total | currency:'INR'"></th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-lg-4 text-black">
                        <div class="d-flex mb-1">
                            <span class="font-weight-bold">NET AMOUNT: </span>
                            <span class="ml-2" [textContent]="netAmount | currency:'INR'"></span>
                        </div>
                    </div>
                    <div class="col-lg-4 text-black">
                        <div class="d-flex mb-1">
                            <span class="font-weight-bold">DUE AMOUNT: </span>
                            <span class="ml-2" [textContent]="totalAmount | currency:'INR'"></span>
                        </div>
                    </div>      
                </div>

                <div class="row mt-2">
                    <div class="col-lg-6 text-black">
                        <div class="mb-1">
                            <span class="font-weight-bold">Created By: </span>
                            <span [textContent]="record.createdByName"></span>
                        </div>
                        <div>
                            <span class="font-weight-bold">Created Date: </span>
                            <span [textContent]="record.createdDate | date:'dd-MM-yyyy, h:mm:ss a'"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
